import { render, staticRenderFns } from "./NgImageUploader.vue?vue&type=template&id=2ab647c2&scoped=true"
import script from "./NgImageUploader.vue?vue&type=script&lang=js"
export * from "./NgImageUploader.vue?vue&type=script&lang=js"
import style0 from "./NgImageUploader.vue?vue&type=style&index=0&id=2ab647c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab647c2",
  null
  
)

export default component.exports